export default __webpack_public_path__ + "static/media/GasWeFlowImg1.2efaa91a.png";